import { cn } from '@/lib/cn';

interface UsageMeterProps {
  label: string;
  used: number;
  limit: number;
  className?: string;
}

export function UsageMeter({ label, used, limit, className }: UsageMeterProps) {
  // `limit = 0` is the legacy "no cap configured" sentinel — render it as ∞
  // and skip the progress bar fill entirely (no meaningful percentage when
  // there's no ceiling).
  const unlimited = limit <= 0;
  const percent = unlimited ? 0 : Math.min(100, Math.round((used / limit) * 100));
  const tone =
    percent >= 100
      ? 'bg-[var(--color-error)]'
      : percent >= 80
        ? 'bg-[var(--color-warn)]'
        : 'bg-[var(--color-accent)]';
  return (
    <div className={cn('rounded-xl border border-[var(--color-border-default)] bg-[var(--color-bg-surface)] p-4', className)}>
      <div className="mb-2 flex items-baseline justify-between gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-[var(--color-fg-muted)]">
          {label}
        </span>
        <span className="text-sm font-bold tabular-nums">
          {used}
          <span className="text-[var(--color-fg-subtle)]"> / {unlimited ? '∞' : limit}</span>
        </span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-[var(--color-bg-elevated)]">
        <div
          className={cn('h-full rounded-full transition-all', tone)}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
